export const useExternalOrderStore = defineStore('externalOrderData', () => {
  const { putExternalOrder } = useApi()
  const { message } = useAlarm()

  const iccid = ref<string>('')
  const orderId = ref<string>('')
  const errorKey = ref<string>('')
  const loginFromEnrollLink = ref<boolean>(false)

  const requestEnroll = async () => {
    try {
      const res:any = await putExternalOrder(orderId.value, iccid.value)
      if (res?.success) {
        message('info', '준비가 완료되었어요.', false, true, 2000, 90, 'message-plain')
        iccid.value = ''
        orderId.value = ''
        loginFromEnrollLink.value = false
        navigateTo('/inventory')
      } else {
        errorKey.value = res.error.key
        message('info', res.error.message, false, true, 2000, 90, 'message-plain')
        loginFromEnrollLink.value = false
        navigateTo('/inventory/enroll')
      }
    } catch (error) {
      console.warn(error)
      message('warning', '등록에 실패했어요.', false, true, 2000, 90, 'message-plain')
    }
  }

  const checkExternalOrder = () => {
    if (loginFromEnrollLink.value) {
      requestEnroll()
    }
  }

  return {
    iccid,
    orderId,
    errorKey,
    loginFromEnrollLink,
    requestEnroll,
    checkExternalOrder
  }
}, {
  persist: true
})

